import React, { useState } from 'react';

import { Link } from 'react-router-dom';
import { Player } from 'video-react';

import poster from './../../assets/images/static/erpDashboard.jpg';

import {
  WatchDemoSection,
  HeadingSection,
  HeadingTitle,
  DemoVideoSection,
  StyledVideoDiv,
  StyledVideoLink,
  ExitButton,
} from './styled';

const WatchDemo = () => {

  const eretailvideo = 'https://s3.us-west-2.amazonaws.com/videos-eretailpoint.com/eretailVideo.mp4';

  const [state, setState] = useState("video");
  
  const showFullScreenVideo = () => {
    setState("videoLink");
    if (state === "videoLink") {
      setState("video")
    }
  }

  const exitFullScreen = () => {
    (state === "videoLink") ? setState("video") : setState("videLink");
  }

  return (
    <WatchDemoSection id="aboutus">
      <HeadingSection>
        <HeadingTitle>Watch Free Demo</HeadingTitle>
      </HeadingSection>
      <DemoVideoSection>
        <StyledVideoDiv
          onClick={showFullScreenVideo}
          className={state}
        >
          <ExitButton onClick={exitFullScreen}>
            Exit Full Screen
          </ExitButton>
          <Player
            playsInline={true}
            poster={poster}
            src={eretailvideo}
          />
        </StyledVideoDiv>
        <StyledVideoLink className='hidden'>
          <Link to="/pages/tutorials">More Videos</Link>
        </StyledVideoLink>
      </DemoVideoSection>
    </WatchDemoSection>
  )
}

export default WatchDemo;
